function markFormFieldsTouched(form) {
  return Object.entries(form).reduce(
    (prev, [field, valueState]) => {
      if (!valueState) {
        return prev;
      }
      if (valueState.isValid) {
        return {
          ...prev,
          [field]: valueState
        };
      }
      return {
        ...prev,
        [field]: {
          ...valueState,
          isTouched: true
        }
      };
    },
    {}
  );
}
export {
  markFormFieldsTouched
};
//# sourceMappingURL=mark-fields-touched.js.map
